module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"HOME":"Home","WELCOME":"Welcome","ASK":"Ask Connxions","SEND":"Send"}}')
  delete Component.options._Ctor
}
